import React from "react";
import Navigation from "../../../components/Navigation";
import ProjectTypeForm from "./ProjectTypeForm/ProjectTypeForm";

const SelectProjectType = () => {
  return (
    <div className="bg-[#F7F7F7] calc-h-header">
      <Navigation />
      <div className="p-[35px]">
        <h2 className="text-2xl font-semibold mb-2">Select Project Type</h2>
        <p className="text-[#747474] text-[16px]">
          To get started, please let us know what project type you want to create.
        </p>
      </div>
      <ProjectTypeForm />
    </div>
  );
};

export default SelectProjectType;